import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=c98abf4e&scoped=true&"
import script from "./ViewProduct.vue?vue&type=script&lang=js&"
export * from "./ViewProduct.vue?vue&type=script&lang=js&"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&id=c98abf4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98abf4e",
  null
  
)

export default component.exports